import { Controller } from "@hotwired/stimulus"
import { split, includes, without, withReplacedSlot } from "../lib/query_tokens"

// The section drawer's starter chips (#3523): a chip presses its token into
// the Search field or lifts it out again, on the search page's token rules,
// and dispatches the field's input event so the live count follows. The
// intro's search-page link carries the field's query as typed (#3618).
export default class extends Controller {
  static targets = ["field", "chip", "link"]

  connect() {
    this.sync()
  }

  toggle({ params: { token } }) {
    const current = this.#tokens()
    const next = includes(current, token) ? without(current, [token]) : withReplacedSlot(current, token)
    this.fieldTarget.value = next.join(" ")
    this.fieldTarget.dispatchEvent(new Event("input", { bubbles: true }))
  }

  sync() {
    const current = this.#tokens()
    for (const chip of this.chipTargets) {
      chip.setAttribute("aria-pressed", String(includes(current, chip.dataset.queryStartersTokenParam)))
    }
    this.#carryQuery(current.join(" "))
  }

  #carryQuery(query) {
    if (!this.hasLinkTarget) return

    const url = new URL(this.linkTarget.href)
    if (query) url.searchParams.set("query", query)
    else url.searchParams.delete("query")
    this.linkTarget.href = url.toString()
  }

  #tokens() {
    return split(this.fieldTarget.value)
  }
}
